<template>
	<div class="container">
		<div class="top-wrapper">
			<flex-line v-if="!inviter_id" class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="invname" placeholder="填写推荐人" maxlength="25" /><label v-if="!invname" class="tips">推荐人的会员名称</label></div></flex-line>
			<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="username" placeholder="填写用户名" maxlength="25" /><label v-if="!username" class="tips">3-25位，可以包含英文与数字</label></div></flex-line>
			<flex-line v-if="config.captcha_status_register=='1'" class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" v-model="pictureCode" placeholder="请输入图片验证码" maxlength="6" /><img @click="changePictureCode" :src="pictureCodeUrl" class="countdown" ></div></flex-line>
			<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="paypass" placeholder="设置安全码" maxlength="20" /><label class="tips" v-if="!paypass">6-20位数字/字母/符号</label></div></flex-line>
			<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" placeholder="设置密码" maxlength="20" /></div></flex-line>
			<flex-line class="field-line input-wrapper" :show-border="true"><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="confirmPassword" placeholder="确认密码" maxlength="20" /><label v-if="!confirmPassword" class="tips">6-20位数字/字母/符号</label></div></flex-line>
		</div>

		<div class="common-btn ds-button-large mt-10 mb-10" @click="onSubmit">注册</div>
		<div class="link-wrapper">
			<span class="left-text">点击注册表示同意</span>
			<span class="right-text" @click="onAgreement">《用户协议》</span>
		</div>
	</div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { register } from '../../../api/memberRegister'
import { getSmsCaptcha, checkPictureCaptcha } from '../../../api/common'
import flexLine from '../../flexLine'
export default {
  name: 'RegisterByEmail',
  data () {
    return {
      pictureCodeUrl: '',
      pictureCode: '',
      pictureCodeValid: false,
      pictureCodeWait: false,
	  invname:'',
      username: '',
      password: '',
	  paypass: '',
      confirmPassword: '',
      aggrementUrl: ''
    }
  },
  components: {
    flexLine
  },
  created: function () {
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      inviter_id: state => isNaN(parseInt(state.member.inviterId)) ? 0 : parseInt(state.member.inviterId),
      config: state => state.config.config
    })
  },
  mounted () {
    this.changePictureCode()
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    changePictureCode () {
      this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    goBack () {
      this.$router.go(-1)
    },
    goProfile () {
      this.$router.go(-2)
    },
    goProfileAdd () {
      this.$router.push({ name: 'profileAdd' })
    },
    check () {
	  let invname  = this.invname,
          username = this.username,
          password = this.password,
          confirmPassword = this.confirmPassword
      if (!this.inviter_id && (invname.length < 3 || invname.length > 25)) {
        Toast('请正确输入推荐人的会员名')
        return false
      }
      if (username.length < 3 || username.length > 25) {
        Toast('请输入3-25个字符的用户名')
        return false
      }
	  if (this.paypass.length < 6 || this.paypass.length > 20) {
	    Toast('请输入6-20个字符的安全码')
	    return false
	  }
      if (password.length === 0) {
        Toast('请输入密码')
        return false
      }
      if (password.length < 6 || password.length > 20) {
        Toast('请输入6-20个字符的密码')
        return false
      }
      if (confirmPassword.length === 0) {
        Toast('请输入确认密码')
        return false
      }
      if (password.length !== confirmPassword.length) {
        Toast('确认密码与输入密码不一致')
        return false
      }
      if (password !== confirmPassword) {
        Toast('确认密码与输入密码不一致')
        return false
      }

      return true
    },
    signup () {
      if (!this.check()) {
        return
      }
      Indicator.open()      
      register(this.username, this.password, this.confirmPassword, this.paypass, this.inviter_id, this.invname, this.pictureCode).then(
        response => {
          Indicator.close()
		  this.saveAuthInfo({ token: response.result.token, info: response.result.info })
		  this.$router.push({ name: 'MemberIndex' })          
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit () {
      this.signup()
    },
    onAgreement () {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
	.ds-button-large{margin:0 $pageSpace}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		//background-color: $primaryColor;
		.input-wrapper {
			font-size:$subFontSize;
			display: flex;
			flex-direction: row;
			align-content: flex-start;
			align-items: center;
			background-color: #fff;
			height:2.2rem;
			padding-left:0.5rem;
			img {
				height: 1.75rem;width: auto;
				margin: 0;
				padding: 0;
			}
			input {
				flex: 1;
			}
			.bottom-input {
				border-bottom-width: 0;
			}
		}
		.link-wrapper {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: stretch;
			span {
				font-size:$subFontSize;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
			}
			.left-text {
				color: $descTextColor;
			}
			.right-text {
				color: $primaryColor;
			}
		}
	}
	.top-wrapper {
		margin:0 $pageSpace;
	}
	.bottom-wrapper {
		margin-top:0.5rem;
	}
	.tips {
		color: $descTextColor;
		font-size:$fontSize;
		white-space: nowrap;
		position: absolute;
		right: 0;
		top:50%;
		margin-top:-.3rem;
	}
	.countdown {min-width:4rem;margin-right:0.5rem;}
	.field-line-right{position: relative}
	.field-input{
	  text-align: left !important;
	}
</style>
